<template>
  <div>
    <v-row justify="center">
      <v-col
        cols="12"
        md="10"
        class="pb-0"
      >
        <div class="text-center">
          <h3 class="mb-2">
            <v-avatar
              v-if="channel.logoId"
              tile
            >
              <v-img
                contain
                class="p-r-10"
                :src="'https://playout006.noisypeak.com/api/v1/upload/' + channel.logoId + '?img.crop=30x30'"
                height="30"
              />
            </v-avatar>
            {{ channel.name }}
            <v-tooltip
              v-for="admin in admins"
              :key="admin.id"
              top
            >
              <template v-slot:activator="{on, attrs}">
                <v-btn
                  dark
                  fab
                  depressed
                  small
                  class="ml-2 m-b-5"
                  v-on="on"
                  @click="openAdminPanel(admin)"
                >
                  <img
                    style="min-width: 16px; width: 16px;"
                    :src="admin.avatar"
                    v-bind="attrs"
                    alt=""
                  >
                </v-btn>
              </template>
              <span>{{ admin.username }}</span>
            </v-tooltip>
          </h3>
        </div>
      </v-col>
    </v-row>
    <base-card>
      <v-tabs
        v-model="tab"
        background-color=""
      >
        <v-tab
          v-for="t in tabs"
          :key="t.name"
        >
          {{ t.name }}
        </v-tab>
      </v-tabs>
      <v-row no-gutters>
        <v-col
          cols="12"
          md="1"
        >
          <div class="row no-gutters pb-0">
            <div class="d-flex align-center flex-column col col-12 p-t-10">
              <v-icon
                color="#304156"
                size="28"
              >
                mdi-file-video
              </v-icon>
              <p class="greyBold--text text-18 mb-n2">
                {{ totalAssets }}
              </p>
              <p class="media-subtitle">
                Assets
              </p>
            </div>
            <div class="d-flex align-center flex-column col col-12">
              <v-icon
                color="#304156"
                size="28"
              >
                mdi-clock
              </v-icon>
              <p class="greyBold--text text-18 mb-n2">
                {{ adBlockDuration }}m ad
              </p>
              <p class="media-subtitle">
                every {{ minInterval }}m
              </p>
            </div>
            <div class="d-flex align-center flex-column col col-12">
              <v-icon
                v-if="inContentAdvertising"
                color="#304156"
                size="28"
              >
                mdi-check
              </v-icon>
              <v-icon
                v-else
                color="#304156"
                size="28"
              >
                mdi-minus
              </v-icon>
              <p class="media-subtitle">
                In-content ad
              </p>
            </div>
            <div class="d-flex align-center flex-column col col-12 mb-0 pb-0">
              <v-icon
                color="#304156"
                size="28"
              >
                mdi-arrow-right
              </v-icon>
              <p class="greyBold--text text-18 mb-n2 mb-0 pb-0">
                {{ channel.autoSchedulerDepthStr }}
              </p>
              <p class="media-subtitle">
                Schedule
              </p>
            </div>
          </div>
        </v-col>
        <v-col
          cols="12"
          md="6"
          class="d-flex align-center flex-column"
        >
          <video-player
            ref="videoPlayer"
            :src="playerURL"
            @ready="playerReadied"
          />
        </v-col>
        <v-col
          cols="12"
          md="5"
        >
          <v-sheet
            max-height="360"
          >
            <div
              ref="epg_events"
              style="width: 100%; min-height: 150px; max-height: 360px; display: inline-block; overflow-y: auto;"
            >
              <v-list
                class="epg-events"
              >
                <template
                  v-for="event in epgEvents"
                  ref="events"
                >
                  <v-divider
                    :key="`sep`+event.id"
                    class="ma-0 pa-0"
                  />

                  <v-list-item
                    :key="event.id"
                    :class="{ 'blue lighten-5': currentEvent && event.id === currentEvent.id }"
                  >
                    <v-list-item-avatar tile>
                      {{ moment(event.start).format('HH:mm') }}
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title v-html="event.program.name" />
                      <v-progress-linear
                        v-if="currentEvent && event.id === currentEvent.id"
                        :value="playedProgress"
                        color="blue lighten-2"
                        class="ma-0 pa-0"
                        height="5"
                      />
                    </v-list-item-content>
                    <v-list-item-avatar tile>
                      <v-img
                        style="width: 40px; height: 40px;"
                        :src="event.program.pictureId ? 'https://playout006.noisypeak.com/api/v1/upload/' + event.program.pictureId + '?img.crop=40x40' : defaultPoster"
                      />
                    </v-list-item-avatar>
                  </v-list-item>
                </template>
              </v-list>
            </div>
          </v-sheet>
        </v-col>
        <!--v-col
          cols="12"
          md="12"
          class="mb-10"
        >
          <div class="mt-10">
            <v-tabs
              v-model="tab"
              centered
            >
              <v-tab
                v-for="item in items"
                :key="item.tab"
              >
                {{ item.tab }}
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item
                v-for="item in items"
                :key="item.tab"
              >
                <v-card flat>
                  <v-card-text>
                    {{
                      item.content
                    }}
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </div>
        </v-col-->
      </v-row>
    </base-card>

    <v-row class="mt-5">
      <v-col
        cols="12"
        md="10"
      >
        <base-card>
          <v-card-text>
            <div
              class="d-flex align-center flex-wrap mb-2"
            >
              <v-icon
                color=""
                class="pa-1 mr-2"
              >
                mdi-link
              </v-icon>
              <p class="ma-0">
                Main Distribution URL:
                <span>
                  <a
                    :href="channel.streamURL"
                    target="_blank"
                    class="ma-0 font-weight-medium"
                  >{{ channel.streamURL }}
                  </a>
                  <v-btn
                    class="m-l-10"
                    x-small
                    icon
                    @click.stop="handleCopy(channel.streamURL)"
                  >
                    <v-icon>
                      mdi-content-copy
                    </v-icon>
                  </v-btn>
                </span>
              </p>
            </div>
            <div
              v-if="channel.xmltv"
              class="d-flex align-center flex-wrap mb-2"
            >
              <v-icon
                color=""
                class="pa-1 mr-2"
              >
                mdi-link
              </v-icon>
              <p class="ma-0">
                XMLTV URL:
                <span>
                  <a
                    :href="channel.xmltv.resultURLAuto"
                    target="_blank"
                    class="ma-0 font-weight-medium"
                  >
                    {{ channel.xmltv.resultURLAuto }}
                  </a>
                  <v-btn
                    class="m-l-10"
                    x-small
                    icon
                    @click.stop="handleCopy(channel.xmltv.resultURLAuto)"
                  >
                    <v-icon>
                      mdi-content-copy
                    </v-icon>
                  </v-btn>
                </span>
              </p>
            </div>
            <div
              class="d-flex align-center flex-wrap mb-2"
            >
              <v-icon
                color=""
                class="pa-1 mr-2"
              >
                mdi-attachment
              </v-icon>
              <p class="ma-0">
                Logo and Graphics URL:
                <span>
                  <a
                    :href="channel.graphicsURL"
                    target="_blank"
                    class="ma-0 font-weight-medium"
                  >
                    {{ channel.graphicsURL || 'n/a' }}
                  </a>
                  <v-btn
                    class="m-l-10"
                    x-small
                    icon
                    @click.stop="editGraphicsURL()"
                  >
                    <v-icon>
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </span>
              </p>
            </div>
            <div
              class="d-flex align-center flex-wrap mb-2"
            >
              <v-icon
                color=""
                class="pa-1 mr-2"
              >
                mdi-monitor
              </v-icon>
              <p class="ma-0">
                Where To View:
                <span>
                  <a
                    :href="channel.whereToView"
                    target="_blank"
                    class="ma-0 font-weight-medium"
                  >
                    {{ channel.whereToView || 'n/a' }}
                  </a>
                  <v-btn
                    class="m-l-10"
                    x-small
                    icon
                    @click.stop="editWhereToView()"
                  >
                    <v-icon>
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </span>
              </p>
            </div>
          </v-card-text>
        </base-card>
      </v-col>
      <v-col
        cols="12"
        md="2"
      >
        <base-card>
          <v-card-text>
            <h5
              v-if="!channel.suspended"
              class="text-18"
            >
              Active channel
            </h5>
            <h5
              v-else
              class="text-18"
            >
              Paused channel
            </h5>
            <p>Created: {{ moment.utc(channel.createTime).format('D MMM YY') }}</p>
            <v-btn
              v-if="!channel.suspended"
              depressed
              color="error"
              @click="togglePauseChannel()"
            >
              <v-icon left>
                mdi-pause
              </v-icon>
              Pause
            </v-btn>
            <v-btn
              v-else
              depressed
              color="success"
              @click="togglePauseChannel()"
            >
              <v-icon left>
                mdi-play
              </v-icon>
              Start
            </v-btn>
          </v-card-text>
        </base-card>
      </v-col>
    </v-row>

    <base-card class="mt-5">
      <v-card-text>
        <div class="row">
          <div class="col-md-4 col-12">
            <h5 class="text-18">
              Short Description
              <v-btn
                small
                icon
                class="m-l-5"
                style="margin-bottom: 3px"
                color="primary"
                @click="editShortDescription()"
              >
                <v-icon size="18">
                  mdi-pencil
                </v-icon>
              </v-btn>
            </h5>
            <p>
              {{ channel.shortDescription }}<span class="text--disabled" v-if="!channel.shortDescription">N/A</span>
            </p>
            <h5 class="text-18">
              Long Description
              <v-btn
                small
                icon
                class="m-l-5"
                style="margin-bottom: 3px"
                color="primary"
                @click="editLongDescription()"
              >
                <v-icon size="18">
                  mdi-pencil
                </v-icon>
              </v-btn>
            </h5>
            <p>
              {{ channel.description }}<span class="text--disabled" v-if="!channel.description">N/A</span>
            </p>
          </div>
          <div class="col-md-7 offset-lg-1 col-12">
            <div class="row no-gutters">
              <div class="mb-3 col-md-6 col-12">
                <h5 class="text-18">
                  Name
                </h5>
                <p>{{ channel.name }}</p>
              </div>
              <div class="col-md-6 col-12">
                <h5 class="text-18">
                  Company
                </h5>
                <p class="m-b-5">
                  {{ channel.instance.name }}
                </p>
                <!--a href="#">Info</a-->
              </div>
            </div>
            <div class="row no-gutters">
              <div class="mb-3 col-md-6 col-12">
                <h5 class="text-18">
                  Language
                  <v-btn
                    small
                    icon
                    class="m-l-5"
                    style="margin-bottom: 3px"
                    color="primary"
                    @click="editLang()"
                  >
                    <v-icon size="18">
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </h5>
                <p>{{ channel.lang }}<span class="text--disabled" v-if="!channel.lang">N/A</span></p>
              </div>
              <div class="mb-3 col-md-6 col-12">
                <h5 class="text-18">
                  Timezone
                </h5>
                <p>{{ tz }}</p>
              </div>
            </div>
            <div class="row no-gutters">
              <div class="col col-6">
                <h5 class="text-18">
                  Genres
                  <v-btn
                    small
                    icon
                    class="m-l-5"
                    style="margin-bottom: 3px"
                    color="primary"
                    @click="editGenres()"
                  >
                    <v-icon size="18">
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </h5>
                <ul v-if="!channel.genres.length">
                  <li>n/a</li>
                </ul>
                <ul v-if="channel.genres.length">
                  <li
                    v-for="genre in channel.genres"
                    :key="genre.id"
                  >
                    {{ genre.name }}
                  </li>
                </ul>
              </div>
              <div class="col col-6">
                <h5 class="mb-0 text-18">
                  Rating
                  <v-btn
                    small
                    icon
                    class="m-l-5"
                    style="margin-bottom: 3px"
                    color="primary"
                    @click="editRating()"
                  >
                    <v-icon size="18">
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </h5>
                <p>{{ channel.rating }}</p>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
    </base-card>

    <base-card class="mt-5">
      <v-card-text>
        <div class="row">
          <div class="col-md-4 col-12">
            <h5 class="text-18">
              Geo Exclusions
              <v-btn
                small
                icon
                class="m-l-5"
                style="margin-bottom: 3px"
                color="primary"
                @click="editGeoExclusions()"
              >
                <v-icon size="18">
                  mdi-pencil
                </v-icon>
              </v-btn>
            </h5>
            <p>{{ channel.geoExclusionsStr }}<span class="text--disabled" v-if="!channel.geoExclusionsStr">N/A</span></p>
          </div>
          <div class="col-md-7 offset-lg-1 col-12">
            <div class="row no-gutters">
              <div class="mb-3 col-md-6 col-12">
                <h5 class="text-18">
                  CCPA US Privacy
                  <v-btn
                    small
                    icon
                    class="m-l-5"
                    style="margin-bottom: 3px"
                    color="primary"
                    @click="editUSPrivacy()"
                  >
                    <v-icon size="18">
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </h5>
                <p>{{ channel.USPrivacy }}</p>
              </div>
              <div class="col-md-6 col-12">
                <h5 class="text-18">
                  IAB Category ID
                  <v-btn
                    small
                    icon
                    class="m-l-5"
                    style="margin-bottom: 3px"
                    color="primary"
                    @click="editIABCategoryID()"
                  >
                    <v-icon size="18">
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </h5>
                <p class="m-b-5">
                  {{ channel.IABCategory }}
                </p>
              </div>
            </div>
            <div class="row no-gutters">
              <div class="mb-3 col-md-6 col-12">
                <h5 class="text-18">
                  Per Deal Approval
                  <v-btn
                    small
                    icon
                    class="m-l-5"
                    style="margin-bottom: 3px"
                    color="primary"
                    @click="editPerDealApproval()"
                  >
                    <v-icon size="18">
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </h5>
                <p>{{ channel.perDealApproval }}<span class="text--disabled" v-if="!channel.perDealApproval">N/A</span></p>
              </div>
              <div class="mb-3 col-md-6 col-12">
                <h5 class="text-18">
                  Target Package
                  <v-btn
                    small
                    icon
                    class="m-l-5"
                    style="margin-bottom: 3px"
                    color="primary"
                    @click="editTargetPackage()"
                  >
                    <v-icon size="18">
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </h5>
                <p>{{ channel.targetPackage }}<span class="text--disabled" v-if="!channel.targetPackage">N/A</span></p>
              </div>
            </div>
            <div class="row no-gutters">
              <div class="mb-3 col-md-6 col-12">
                <h5 class="text-18">
                  COPPA
                  <v-btn
                    small
                    icon
                    class="m-l-5"
                    style="margin-bottom: 3px"
                    color="primary"
                    @click="editCoppa()"
                  >
                    <v-icon size="18">
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </h5>
                <p>{{ channel.coppa }}</p>
              </div>
              <div class="mb-3 col-md-6 col-12">
                <h5 class="text-18">
                  Content ID
                  <v-btn
                    small
                    icon
                    class="m-l-5"
                    style="margin-bottom: 3px"
                    color="primary"
                    @click="editContentId()"
                  >
                    <v-icon size="18">
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </h5>
                <p>{{ channel.contentId }}<span class="text--disabled" v-if="!channel.contentId">N/A</span></p>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
    </base-card>

    <base-card class="mt-5">
      <v-card-text>
        <div class="row">
          <div class="col-md-4 col-12">
            <h5 class="text-18">
              Playout Logo
            </h5>
            <v-img
              width="200"
              height="200"
              contain
              class="grey darken-4 m-b-20 m-l-30"
              :src="channel.logoId ? 'https://playout006.noisypeak.com/api/v1/upload/' + channel.logoId : defaultIcon"
            />
            <v-file-input
              v-model="playoutLogoFile"
              class="pointer"
              placeholder="Upload a new logo (JPEG, PNG)"
              truncate-length="15"
              label="File input"
              style="width: 230px;"
              show-size
              accept="image/png, image/jpeg"
              prepend-icon="mdi-paperclip"
              :loading="fileLoading"
              @change="fileUpload('playoutLogo', playoutLogoFile)"
            />
          </div>
          <div class="col-md-4 col-12">
            <h5 class="text-18">
              SC White Logo
            </h5>
            <v-img
              width="200"
              height="200"
              contain
              class="grey darken-4 m-b-20 m-l-30"
              :src="channel.whiteLogoURL ? channel.whiteLogoURL : defaultIcon"
            />
            <v-file-input
              v-model="whiteLogoFile"
              class="pointer"
              placeholder="Upload a new logo (JPEG, PNG)"
              truncate-length="15"
              label="File input"
              style="width: 230px;"
              show-size
              accept="image/png, image/jpeg"
              prepend-icon="mdi-paperclip"
              :loading="whiteLogoLoading"
              @change="fileUpload('whiteLogo', whiteLogoFile)"
            />
          </div>
          <div class="col-md-4 col-12">
            <h5 class="text-18">
              SC Color Logo
            </h5>
            <v-img
              width="200"
              height="200"
              contain
              class="grey darken-4 m-b-20 m-l-30"
              :src="channel.colorLogoURL ? channel.colorLogoURL : defaultIcon"
            />
            <v-file-input
              v-model="colorLogoFile"
              class="pointer"
              placeholder="Upload a new logo (JPEG, PNG)"
              truncate-length="15"
              label="File input"
              style="width: 230px;"
              show-size
              accept="image/png, image/jpeg"
              prepend-icon="mdi-paperclip"
              :loading="colorLogoLoading"
              @change="fileUpload('colorLogo', colorLogoFile)"
            />
          </div>
        </div>
      </v-card-text>
    </base-card>

    <!--div class="row">
      <div class="col-md-6 p-b-0">
        <a
          href="#"
          :class="{ 'text--disabled': prevChannel === -1 }"
          @click.prevent="goToDetails(prevChannel)"
        >
          <i class="mdi mdi-arrow-left p-r-5" />
          prev channel
          <span v-if="prevChannel.name">"{{ prevChannel.name }}"</span>
        </a>
      </div>
      <div class="col-md-6 p-b-0 text-right">
        <a
          href="#"
          :class="{ 'text--disabled': nextChannel === -1 }"
          @click.prevent="goToDetails(nextChannel)"
        >
          next channel
          <span v-if="nextChannel.name">"{{ nextChannel.name }}"</span>
          <i class="mdi mdi-arrow-right p-r-5" />
        </a>
      </div>
    </div-->
    <!-- Rating Edit Form  -->
    <v-dialog
      v-model="editFormRating"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5"> Rating of the channel "{{ channel.name }}"</span>
        </v-card-title>
        <v-card-text>
          <v-radio-group
            v-model="editedRating"
            row
          >
            <v-radio
              label="TVY"
              value="TVY"
            />
            <v-radio
              label="TVY7"
              value="TVY7"
            />
            <v-radio
              label="TVG"
              value="TVG"
            />
            <v-radio
              label="TV14"
              value="TV14"
            />
            <v-radio
              label="TVPG"
              value="TVPG"
            />
            <v-radio
              label="TVMA"
              value="TVMA"
            />
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog()"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            :loading="formLoading"
            @click="saveRating()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- USPrivacy Edit Form  -->
    <v-dialog
      v-model="editFormUSPrivacy"
      max-width="400px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">"{{ channel.name }}" CCPA US Privacy</span>
        </v-card-title>
        <v-card-text class="mb-0 pb-0">
          <v-text-field
            v-model.trim="editedUSPrivacy"
            clearable
            required
            outlined
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog()"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            class="mr-2"
            :loading="formLoading"
            @click="saveUSPrivacy()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- IAB Category ID Edit Form -->
    <v-dialog
      v-model="editFormIABCategory"
      max-width="400px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">"{{ channel.name }}" IAB Category ID</span>
        </v-card-title>
        <v-card-text class="mb-0 pb-0">
          <v-text-field
            v-model="editedIABCategory"
            clearable
            required
            dense
            outlined
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog()"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            class="mr-2"
            :loading="formLoading"
            @click="saveIABCategory()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Genres Edit Form  -->
    <v-dialog
      v-model="editFormGenres"
      max-width="800px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">"{{ channel.name }}" Genres</span>
        </v-card-title>
        <v-card-text class="mb-0 pb-0">
          <v-autocomplete
            v-model="editedGenres"
            :items="genres"
            return-object
            label="Genres"
            item-text="name"
            multiple
            outlined
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog()"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            class="mr-2"
            :loading="formLoading"
            @click="saveGenres()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Short Description Edit Form -->
    <v-dialog
      v-model="editFormShortDescription"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">"{{ channel.name }}" Short Description</span>
        </v-card-title>
        <v-card-text class="mb-0 pb-0">
          <v-textarea
            v-model.trim="editedShortDescription"
            append-icon="mdi-comment-text"
            rows="2"
            auto-grow
            counter="140"
            outlined
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog()"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            class="mr-2"
            :loading="formLoading"
            @click="saveShortDescription()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Long Description Edit Form -->
    <v-dialog
      v-model="editFormLongDescription"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">"{{ channel.name }}" Long Description</span>
        </v-card-title>
        <v-card-text class="mb-0 pb-0">
          <v-textarea
            v-model="editedLongDescription"
            append-icon="mdi-comment-text"
            rows="2"
            auto-grow
            counter="500"
            outlined
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog()"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            class="mr-2"
            :loading="formLoading"
            @click="saveLongDescription()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Geo Edit Form -->
    <v-dialog
      v-model="editFormGeo"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">"{{ channel.name }}" Geo Exclusions</span>
        </v-card-title>
        <v-card-text>
          <v-col cols="12">
            <v-radio-group
              v-model="denyAll"
              column
              class="p-b-20"
            >
              <v-radio
                label="Only allowed in..."
                color="success darken-3"
                value="1"
              />
              <v-radio
                label="Not in..."
                color="red darken-3"
                value="0"
              />
            </v-radio-group>
            <v-autocomplete
              v-model="selectedLocations"
              :items="locations"
              color="blue-grey lighten-2"
              label="Select countries"
              item-text="name"
              return-object
              multiple
              outlined
              dense
            >
              <template v-slot:selection="data">
                <v-chip
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  close
                  label
                  outlined
                  @click="data.select"
                  @click:close="removeLocation(data.item)"
                >
                  <v-avatar left>
                    <v-img :src="'/images/flags/' + data.item.code.toLowerCase() + '.svg'" />
                  </v-avatar>
                  {{ data.item.name }}
                </v-chip>
              </template>
              <template v-slot:item="data">
                <template v-if="typeof data.item !== 'object'">
                  <v-list-item-content v-text="data.item" />
                </template>
                <template v-else>
                  <v-list-item-avatar>
                    <img
                      :src="'/images/flags/' + data.item.code.toLowerCase() + '.svg'"
                      alt=""
                    >
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-html="data.item.name" />
                    <v-list-item-subtitle>
                      <span v-if="data.item.type === 'state'">{{ data.item.code }}</span> {{ data.item.type }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </template>
            </v-autocomplete>
          </v-col>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog()"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            class="mr-4"
            :loading="formLoading"
            @click="saveGeoExclusions()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- whereToView Edit Form -->
    <v-dialog
      v-model="editFormWhereToView"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">"{{ channel.name }}" Where To View</span>
        </v-card-title>
        <v-card-text class="mb-0 pb-0">
          <v-text-field
            v-model.trim="editedWhereToView"
            clearable
            required
            prepend-inner-icon="mdi-link"
            placeholder="http://"
            outlined
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog()"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            class="mr-2"
            :loading="formLoading"
            @click="saveWhereToView()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- graphicsURL Edit Form -->
    <v-dialog
      v-model="editFormGraphicsURL"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">"{{ channel.name }}" Graphics URL</span>
        </v-card-title>
        <v-card-text class="mb-0 pb-0">
          <v-text-field
            v-model.trim="editedGraphicsURL"
            clearable
            required
            prepend-inner-icon="mdi-link"
            placeholder="http://"
            outlined
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog()"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            class="mr-2"
            :loading="formLoading"
            @click="saveGraphicsURL()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Lang Edit Form  -->
    <v-dialog
      v-model="editFormLang"
      max-width="400px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">"{{ channel.name }}" Language</span>
        </v-card-title>
        <v-card-text class="mb-0 pb-0">
          <v-autocomplete
            v-model="editedLang"
            :items="langs"
            clearable
            outlined
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog()"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            class="mr-2"
            :loading="formLoading"
            @click="saveLang()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- perDealApproval Edit Form  -->
    <v-dialog
      v-model="editFormPerDealApproval"
      max-width="400px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">"{{ channel.name }}" Per Deal Approval</span>
        </v-card-title>
        <v-card-text class="mb-0 pb-0">
          <v-autocomplete
            v-model="editedPerDealApproval"
            :items="['Per Deal Approval']"
            clearable
            outlined
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog()"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            class="mr-2"
            :loading="formLoading"
            @click="saveDealApproval()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- COPPA  -->
    <v-dialog
      v-model="editFormCoppa"
      max-width="400px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">COPPA</span>
        </v-card-title>
        <v-card-text class="mb-0 pb-0">
          <v-text-field
            v-model="editedCoppa"
            required
            type="number"
            dense
            outlined
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog()"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            class="mr-2"
            :loading="formLoading"
            @click="saveCoppa()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Content ID  -->
    <v-dialog
      v-model="editFormContentId"
      max-width="400px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Content ID</span>
        </v-card-title>
        <v-card-text class="mb-0 pb-0">
          <v-text-field
            v-model.trim="editedContentId"
            outlined
            clearable
            required
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog()"
          >
            Close
          </v-btn>
          <v-btn
            class="mr-2"
            color="primary"
            :loading="formLoading"
            @click="saveContentId()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Target Package Edit Form  -->
    <v-dialog
      v-model="editFormTargetPackage"
      max-width="400px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">"{{ channel.name }}" Target Package</span>
        </v-card-title>
        <v-card-text class="mb-0 pb-0">
          <v-autocomplete
            v-model="editedTargetPackage"
            :items="targetPackages"
            clearable
            outlined
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog()"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            class="mr-2"
            :loading="formLoading"
            @click="saveTargetPackage()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { processGenre, processDistribution, processChannel, processProgram2 } from '@/store/converters'
  import videoPlayer from '@/player/player'
  import moment from 'moment-timezone'
  import config from '@/config'
  import { setClipboard } from '@/helpers/utils'

  export default {
    components: {
      videoPlayer,
    },
    metaInfo: {
      title: 'Playout Channel',
    },
    data () {
      return {
        tab: null,
        tabs: [
          { name: 'Overview' },
          { name: 'Content' },
          { name: 'Distributions' },
        ],
/*        playerOptions: {
          muted: true,
        },*/
        genres: [],
        channels: [],
        channel: {
          id: 0,
          name: '',
          genres: [],
          instance: {},
        },
        editChannel: {
          name: '',
          company: '',
          shortDescription: '',
          longDescription: '',
          url: '',
          genres: [],
        },
        rules: {
          nameRules: [
            (v) => !!v || 'Name is required',
            (v) => (v && v.length <= 1024) || 'Name must be less than 1024 characters',
          ],
        },
        epgEvents: [],
        currentEvent: null,
        polling: null,
        currentUnixTime: moment().utc().unix() * 1000,
        tzOffset: 0,
        tz: '',
        inContentAdvertising: true,
        adBlockDuration: 0,
        minInterval: 0,
        totalAssets: 0,
        admins: [],
        formLoading: false,
        editFormRating: false,
        editedRating: false,
        editFormUSPrivacy: false,
        editedUSPrivacy: '',
        editFormGenres: false,
        editedGenres: [],
        editFormIABCategory: false,
        editedIABCategory: '',
        editFormShortDescription: false,
        editedShortDescription: '',
        editFormLongDescription: false,
        editedLongDescription: '',
        editFormGeo: false,
        locations: [],
        selectedLocations: [],
        denyAll: '0',
        editedWhereToView: '',
        editFormWhereToView: false,
        editedGraphicsURL: '',
        editFormGraphicsURL: false,
        editedLang: '',
        editFormLang: false,
        editedPerDealApproval: '',
        editFormPerDealApproval: false,
        editedTargetPackage: '',
        editFormTargetPackage: false,
        editedCoppa: 0,
        editFormCoppa: false,
        editedContentId: '',
        editFormContentId: false,
        langs: ['en', 'es', 'pt', 'Hindi', 'French', 'German', 'Italian', 'Japanese', 'Chinese', 'Turkish'],
        targetPackages: ['English', 'LATAM', 'Indian', 'African English'],
        playoutLogoFile: null,
        whiteLogoFile: null,
        colorLogoFile: null,
        fileLoading: false,
        whiteLogoLoading: false,
        colorLogoLoading: false,
        playerURL: '',
        player: null,
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
      isFormValid () {
        if (!(this.editChannel.name.length >= 3 && this.editChannel.name.length <= 255)) {
          return false
        }
        if (!this.editChannel.url.startsWith('http')) {
          return false
        }
        return true
      },
      playedProgress () {
        if (!this.currentEvent) return 0
        const eventDuration = this.currentEvent.endOriginal - this.currentEvent.startOriginal
        // eslint-disable-next-line no-mixed-operators
        return (this.currentUnixTime - this.currentEvent.startOriginal) * 100 / eventDuration
      },
      defaultIcon () {
        return '/images/no_logo.jpeg'
      },
      prevChannel () {
        for (let i = 1; i < this.channels.length; i += 1) {
          if (this.channel.id === this.channels[i].id) {
            return this.channels[i - 1]
          }
        }
        return -1
      },
      nextChannel () {
        for (let i = 0; i < this.channels.length - 1; i += 1) {
          if (this.channel.id === this.channels[i].id) {
            return this.channels[i + 1]
          }
        }
        return -1
      },
      defaultPoster () {
        return '/images/no-image-black.png'
      },
    },
    watch: {
      '$route' (to, from) {
        if (to.params.channel_id) {
          this.loadData(to.params.channel_id)
        }
      },
    },
    mounted () {
      this.updateTime()
    },
    beforeDestroy () {
      clearInterval(this.polling)
    },
    created () {
      this.loadData(this.$route.params.channel_id)
    },
    methods: {
      updateTime () {
        this.polling = setInterval(() => {
          this.currentUnixTime = moment().utc().unix() * 1000
          this.findCurrentEvent()
        }, 3 * 1000)
      },
      durationShort (duration) {
        const d = Math.floor(duration / (24 * 60))
        const h = Math.floor((duration - d * 24 * 60) / 60)
        const m = duration - d * 24 * 60 - h * 60

        let res = ''
        if (d > 0) {
          res += `${d}d`
        }
        if (h > 0) {
          res += `${h}h`
        }
        if (m > 0) {
          res += `${m}m`
        }
        return res
      },
      loadData (channelId) {
        this.$store.commit('setPageLoader')

        const channelArgs = {
          id: channelId,
          $expand: 'timezone,watermark,xmltv,instance,ads,genres,geoip_rules',
        }
        const channelReq = this.$store.dispatch('getChannelById', channelArgs)

        const distribReqArgs = {
          'default[eq]': 1,
          'channel.id[eq]': channelId,
        }
        const distribReq = this.$store.dispatch('distributions', distribReqArgs)

        const genreArgs = {
          $orderby: 'name',
        }
        const genreReq = this.$store.dispatch('genres', genreArgs)

        const totalAssetsArgs = {
          'type[eq]': 'movie',
          'channel.id[eq]': channelId,
          'state[in]': 'ready,transcoding',
        }
        const totalAssetsReq = this.$store.dispatch('assetCount', totalAssetsArgs)

        const locationArgs = {
          $orderby: 'name',
        }
        const locationReq = this.$store.dispatch('locations', locationArgs)

        this.setPlayerURL(' ')

        return Promise.all([channelReq, distribReq, genreReq, totalAssetsReq, locationReq])
          .then((res) => {
            this.channel = processChannel(res[0] || {})
            this.tzOffset = moment.tz(moment.tz.guess()).utcOffset() * 60 * 1000 - moment.tz(this.channel.timezone.name).utcOffset() * 60 * 1000
            this.tz = moment.tz(this.channel.timezone.name).format('z')
            this.inContentAdvertising = this.channel.ads.inContentAdvertising
            if (this.channel.ads.adBlockDuration) {
              this.adBlockDuration = this.channel.ads.adBlockDuration % 60 === 0 ? this.channel.ads.adBlockDuration / 60 : Number((this.channel.ads.adBlockDuration / 60).toFixed(1))
            }
            if (this.channel.ads.minInterval) {
              this.minInterval = this.channel.ads.minInterval % 60 === 0 ? this.channel.ads.minInterval / 60 : Number((this.channel.ads.minInterval / 60).toFixed(1))
            }
            this.channel.autoSchedulerDepthStr = this.durationShort(this.channel.autoSchedulerDepth)

            let streamURL = this.channel.streamURLhlsv3

            const distributions = res[1] || []
            if (distributions.length) {
              const processed = processDistribution(distributions[0])
              for (const key in processed.urls) {
                if (key === 'hls3') {
                  this.channel.distributionURL = processed.urls[key]
                  streamURL = processed.urls[key]
                }
              }
            }
            streamURL = streamURL.replace('$origin', 'now')
            streamURL = streamURL.replace('$offset', '-1m_15s')
            streamURL = streamURL.replace(',', '_')
            streamURL = streamURL.replace('distrib010.noisypeak.com', 'distrib.noisypeak.com')

            this.channel.streamURL = streamURL

            this.setPlayerURL(streamURL)

            const genres = res[2] || []
            this.genres = genres.map((g) => processGenre(g))

            this.totalAssets = res[3] || 0

            this.admins = []
            this.getAdmins()
            this.epgEvents = []
            this.getEPG()

            const locations = res[4] || []
            this.locations = locations

            const locationMap = {}
            for (let i = 0; i < locations.length; i += 1) {
              locationMap[locations[i].id] = locations[i]
            }

            for (let i = 0; i < this.channel.locations.length; i += 1) {
              // eslint-disable-next-line no-prototype-builtins
              if (locationMap.hasOwnProperty(this.channel.locations[i].id)) {
                this.channel.locations[i].name = locationMap[this.channel.locations[i].id].name
                this.channel.locations[i].code = locationMap[this.channel.locations[i].id].code
                this.channel.locations[i].type = locationMap[this.channel.locations[i].id].type
              }
            }
            this.geoExclusionsStr()
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
            this.$router.push({ name: 'ChannelsPage' })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      geoExclusionsStr () {
        if (!this.channel.locations.length) {
          this.channel.geoExclusionsStr = ''
          return
        }
        let str = 'Only allowed in '
        if (this.channel.denyAll === '0') {
          str = 'Not in '
        }
        const locations = []
        for (let i = 0; i < this.channel.locations.length; i += 1) {
          const l = this.channel.locations[i]
          const title = l.type === 'state' ? l.name + ' ' + l.code : l.name
          locations.push(title)
        }
        str += locations.join(', ')
        this.channel.geoExclusionsStr = str
      },
      getEPG () {
        const offset = moment.tz(this.channel.timezone.name).utcOffset() * 60

        this.days = []

        const timeNow = moment(moment().utc().unix() * 1000 + offset * 1000).utc()
        const start = timeNow.clone().subtract(1, 'days')
        const end = timeNow.clone().add(1, 'days')

        const params = {
          'end_time[gt]': `${moment(start).utc().format('YYYY-MM-DDTHH:mm:ss')}Z`,
          'start_time[lt]': `${moment(end).utc().format('YYYY-MM-DDTHH:mm:ss')}Z`,
          'channel.id[eq]': this.channel.id,
          $expand: 'pictures',
        }

        this.$store.dispatch('programs2', params)
          .then((result) => {
            const programs = result || []
            this.epgEvents = programs.map((p) => this.processEvent(p))
            this.findCurrentEvent()
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
      },
      getAdmins () {
        const params = {
          'instance.id[eq]': this.channel.instance.id,
        }
        this.$store.dispatch('users', params)
          .then((result) => {
            const users = result || []
            for (let i = 0; i < users.length; i += 1) {
              const user = users[i]
              user.avatar = this.getAvatarImg(user.username)
              this.admins.push(user)
            }
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
      },
      getAvatarImg (username) {
        const firstChar = username.substring(0, 1)
        if (firstChar <= 'i') {
          return require('@/assets/images/avatars/man-1.svg')
        }
        if (firstChar > 'i' && firstChar < 'r') {
          return require('@/assets/images/avatars/man-2.svg')
        }
        return require('@/assets/images/avatars/man-3.svg')
      },
      openAdminPanel (user) {
        this.$store.dispatch('getUserToken', user.id)
          .then((res) => {
            if (res.data) {
              const url = `${config.ADMIN_PANEL}/pass-through/${res.data}`
              window.open(url, '_target')
            }
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
      },
      findCurrentEvent () {
        const t = moment().utc().unix() * 1000
        let found = false
        const epgEventsEl = document.getElementsByClassName('epg-events')
        let items = []
        if (epgEventsEl[0]) {
          items = epgEventsEl[0].childNodes
        }
        const heightMap = {}
        let h = 0
        for (let i = 0; i < items.length; i++) {
          h += items[i].scrollHeight
          heightMap[i] = h
        }

        for (let i = 0; i < this.epgEvents.length; i += 1) {
          const event = this.epgEvents[i]
          if (t >= event.startOriginal && t <= event.endOriginal) {
            found = true
            const container = this.$refs.epg_events
            if (!this.currentEvent || this.currentEvent.id !== event.id || container.scrollTop === 0) {
              this.currentEvent = event
              const self = this
              const index = i * 2
              const scrollHeight = heightMap[index] + i - 50
              setTimeout(function () {
                const container = self.$refs.epg_events
                container.scrollTop = scrollHeight
              }, 100)
            }

            break
          }
        }
        if (!found) {
          this.currentEvent = null
        }
      },
      processEvent (p) {
        const program = processProgram2(p)
        const start = moment(program.startTime).utc().unix() * 1000
        const end = moment(program.endTime).utc().unix() * 1000

        return {
          id: program.id,
          start: start - this.tzOffset,
          end: end - this.tzOffset,
          startOriginal: start,
          endOriginal: end,
          program,
          fixed: p.fixed,
        }
      },
      handleCopy (text) {
        setClipboard(text)
        this.$store.commit('showSnackbar', {
          text: 'Copied',
          timeout: 500,
          color: 'success',
          bottom: true,
        })
      },
      playerReadied (player) {
        this.player = player
      },
      setPlayerURL (url) {
        this.playerURL = url
      },
      togglePauseChannel () {
        this.$store.commit('setPageLoader')
        const channel = {
          id: this.channel.id,
          suspended: !this.channel.suspended,
        }
        const msgSuffix = channel.suspended ? 'paused' : 'started'
        this.$store.dispatch('updateChannel', channel)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'The channel has been ' + msgSuffix,
              timeout: 3000,
              color: 'success',
            })
            this.channel.suspended = channel.suspended
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.$store.commit('resolvePageLoader')
          })
      },
      editRating () {
        this.editedRating = this.channel.rating
        this.editFormRating = true
      },
      editUSPrivacy () {
        this.editedUSPrivacy = this.channel.USPrivacy
        this.editFormUSPrivacy = true
      },
      editIABCategoryID () {
        this.editedIABCategory = this.channel.IABCategory
        this.editFormIABCategory = true
      },
      editGenres () {
        this.editedGenres = this.channel.genres
        this.editFormGenres = true
      },
      editShortDescription () {
        this.editedShortDescription = this.channel.shortDescription
        this.editFormShortDescription = true
      },
      editLongDescription () {
        this.editedLongDescription = this.channel.description
        this.editFormLongDescription = true
      },
      editGeoExclusions () {
        this.denyAll = this.channel.denyAll || '0'
        this.selectedLocations = this.channel.locations || []
        this.editFormGeo = true
      },
      editWhereToView () {
        this.editedWhereToView = this.channel.whereToView
        this.editFormWhereToView = true
      },
      editLang () {
        this.editedLang = this.channel.lang
        this.editFormLang = true
      },
      editGraphicsURL () {
        this.editedGraphicsURL = this.channel.graphicsURL
        this.editFormGraphicsURL = true
      },
      editPerDealApproval () {
        this.editedPerDealApproval = this.channel.perDealApproval
        this.editFormPerDealApproval = true
      },
      editCoppa () {
        this.editedCoppa = this.channel.coppa
        this.editFormCoppa = true
      },
      editContentId () {
        this.editedContentId = this.channel.contentId
        this.editFormContentId = true
      },
      editTargetPackage () {
        this.editedTargetPackage = this.channel.targetPackage
        this.editFormTargetPackage = true
      },
      closeDialog () {
        this.editFormRating = false
        this.editFormUSPrivacy = false
        this.editFormGenres = false
        this.editFormIABCategory = false
        this.editFormShortDescription = false
        this.editFormLongDescription = false
        this.editFormGeo = false
        this.editFormWhereToView = false
        this.editFormGraphicsURL = false
        this.editFormLang = false
        this.editFormPerDealApproval = false
        this.editFormTargetPackage = false
        this.editFormCoppa = false
        this.editFormContentId = false
      },
      saveRating () {
        if (this.formLoading) return
        this.formLoading = true

        const updated = {
          id: this.channel.id,
          rating: this.editedRating,
        }

        this.$store.dispatch('updateChannel', updated)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'The rating has been successfully updated',
              timeout: 3000,
              color: 'success',
            })
            this.channel.rating = this.editedRating
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.closeDialog()
            this.formLoading = false
          })
      },
      saveUSPrivacy () {
        if (this.formLoading) return
        this.formLoading = true

        const updated = {
          id: this.channel.id,
          us_privacy: this.editedUSPrivacy,
        }

        this.$store.dispatch('updateChannel', updated)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'CCPA US Privacy has been successfully updated',
              timeout: 3000,
              color: 'success',
            })
            this.channel.USPrivacy = this.editedUSPrivacy
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.closeDialog()
            this.formLoading = false
          })
      },
      saveIABCategory () {
        if (this.formLoading) return
        this.formLoading = true

        const updated = {
          id: this.channel.id,
          iab_category: this.editedIABCategory,
        }

        this.$store.dispatch('updateChannel', updated)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'IAB Category ID has been successfully updated',
              timeout: 3000,
              color: 'success',
            })
            this.channel.IABCategory = this.editedIABCategory
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.closeDialog()
            this.formLoading = false
          })
      },
      saveGenres () {
        if (this.formLoading) return
        this.formLoading = true

        const updated = {
          id: this.channel.id,
          genres: this.editedGenres,
        }

        this.$store.dispatch('updateChannel', updated)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'Genres have been successfully updated',
              timeout: 3000,
              color: 'success',
            })
            this.channel.genres = this.editedGenres
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.closeDialog()
            this.formLoading = false
          })
      },
      saveShortDescription () {
        if (this.formLoading) return
        this.formLoading = true

        const updated = {
          id: this.channel.id,
          short_description: this.editedShortDescription,
        }

        this.$store.dispatch('updateChannel', updated)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'Short Description has been successfully updated',
              timeout: 3000,
              color: 'success',
            })
            this.channel.shortDescription = this.editedShortDescription
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.closeDialog()
            this.formLoading = false
          })
      },
      saveLongDescription () {
        if (this.formLoading) return
        this.formLoading = true

        const updated = {
          id: this.channel.id,
          description: this.editedLongDescription,
        }

        this.$store.dispatch('updateChannel', updated)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'Long Description has been successfully updated',
              timeout: 3000,
              color: 'success',
            })
            this.channel.description = this.editedLongDescription
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.closeDialog()
            this.formLoading = false
          })
      },
      removeLocation (item) {
        let index = 0
        for (let i = 0; i < this.selectedLocations.length; i += 1) {
          if (this.selectedLocations[i].id === item.id) {
            index = i
          }
        }
        if (index >= 0) this.selectedLocations.splice(index, 1)
      },
      saveGeoExclusions () {
        if (this.formLoading) return
        this.formLoading = true

        const rules = []
        if (this.selectedLocations.length) {
          if (this.denyAll === '1') {
            rules.push({
              name: 'deny all',
              allow: false,
              subject_type: 'everyone',
            })
          } else {
            rules.push({
              name: 'allow all',
              allow: true,
              subject_type: 'everyone',
            })
          }
        }
        for (let i = 0; i < this.selectedLocations.length; i += 1) {
          const rule = {
            subject_type: 'location',
            location_id: this.selectedLocations[i].id,
          }
          rule.allow = this.denyAll === '1'
          rules.push(rule)
        }

        const updated = {
          id: this.channel.id,
          geoip_rules: rules,
        }

        this.$store.dispatch('updateChannel', updated)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'Geo Exclusions have been successfully updated',
              timeout: 3000,
              color: 'success',
            })
            this.channel.locations = this.selectedLocations
            this.channel.denyAll = this.denyAll
            this.geoExclusionsStr()
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.closeDialog()
            this.formLoading = false
          })
      },
      saveWhereToView () {
        if (this.formLoading) return
        this.formLoading = true

        const updated = {
          id: this.channel.id,
          where_to_view: this.editedWhereToView,
        }

        this.$store.dispatch('updateChannel', updated)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: '"Where To View" field has been successfully updated',
              timeout: 3000,
              color: 'success',
            })
            this.channel.whereToView = this.editedWhereToView
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.closeDialog()
            this.formLoading = false
          })
      },
      saveGraphicsURL () {
        if (this.formLoading) return
        this.formLoading = true

        const updated = {
          id: this.channel.id,
          graphics_url: this.editedGraphicsURL,
        }

        this.$store.dispatch('updateChannel', updated)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'Graphics URL has been successfully updated',
              timeout: 3000,
              color: 'success',
            })
            this.channel.graphicsURL = this.editedGraphicsURL
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.closeDialog()
            this.formLoading = false
          })
      },
      saveLang () {
        if (this.formLoading) return
        this.formLoading = true

        const updated = {
          id: this.channel.id,
          lang: this.editedLang || '',
        }

        this.$store.dispatch('updateChannel', updated)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'Language has been successfully updated',
              timeout: 3000,
              color: 'success',
            })
            this.channel.lang = this.editedLang
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.closeDialog()
            this.formLoading = false
          })
      },
      saveDealApproval () {
        if (this.formLoading) return
        this.formLoading = true

        const updated = {
          id: this.channel.id,
          per_deal_approval: this.editedPerDealApproval || '',
        }

        this.$store.dispatch('updateChannel', updated)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: '"Per Deal Approval" field has been successfully updated',
              timeout: 3000,
              color: 'success',
            })
            this.channel.perDealApproval = this.editedPerDealApproval
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.closeDialog()
            this.formLoading = false
          })
      },
      saveContentId () {
        if (this.formLoading) return
        this.formLoading = true

        const updated = {
          id: this.channel.id,
          content_id: this.editedContentId || '',
        }

        this.$store.dispatch('updateChannel', updated)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'Content ID has been successfully updated',
              timeout: 3000,
              color: 'success',
            })
            this.channel.contentId = this.editedContentId
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.closeDialog()
            this.formLoading = false
          })
      },
      saveTargetPackage () {
        if (this.formLoading) return
        this.formLoading = true

        const updated = {
          id: this.channel.id,
          target_package: this.editedTargetPackage || '',
        }

        this.$store.dispatch('updateChannel', updated)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'Target Package has been successfully updated',
              timeout: 3000,
              color: 'success',
            })
            this.channel.targetPackage = this.editedTargetPackage
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.closeDialog()
            this.formLoading = false
          })
      },
      saveCoppa () {
        if (this.formLoading) return
        this.formLoading = true

        const updated = {
          id: this.channel.id,
          coppa: Number(this.editedCoppa) || 0,
        }

        this.$store.dispatch('updateChannel', updated)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: '"COPPA" field has been successfully updated',
              timeout: 3000,
              color: 'success',
            })
            this.channel.coppa = this.editedCoppa
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.closeDialog()
            this.formLoading = false
          })
      },
      fileUpload (tag, fileObj) {
        if (!fileObj) return
        if (this.fileLoading || this.whiteLogoLoading || this.colorLogoLoading) return

        const updated = {
          id: this.channel.id,
        }

        if (tag === 'playoutLogo') {
          this.fileLoading = true
        }
        if (tag === 'whiteLogo') {
          this.whiteLogoLoading = true
        }
        if (tag === 'colorLogo') {
          this.colorLogoLoading = true
        }

        const file = new FormData()
        file.append('uploadfile', fileObj, fileObj.name)

        const params = {
          file,
          instanceId: this.channel.instance.id,
        }

        this.$store.dispatch('upload', params)
          .then((result) => {
            if (tag === 'playoutLogo') {
              Vue.set(this.channel, 'logoId', result.id)
              updated.logo_id = result.id
            }
            if (tag === 'whiteLogo') {
              const resultURL = 'https://playout006.noisypeak.com/api/v1/upload/' + result.id
              Vue.set(this.channel, 'whiteLogoURL', resultURL)
              updated.white_logo_url = resultURL
            }
            if (tag === 'colorLogo') {
              const resultURL = 'https://playout006.noisypeak.com/api/v1/upload/' + result.id
              Vue.set(this.channel, 'colorLogoURL', resultURL)
              updated.color_logo_url = resultURL
            }
            this.$store.dispatch('updateChannel', updated)
              .then(() => {
                this.$store.commit('showSnackbar', {
                  text: 'Logo has been successfully updated',
                  timeout: 3000,
                  color: 'success',
                })
              })
              .catch((errorMsg) => {
                this.$store.commit('showSnackbar', {
                  text: errorMsg,
                  timeout: 6000,
                  color: 'error',
                })
              })
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.fileLoading = false
            this.whiteLogoLoading = false
            this.colorLogoLoading = false
          })
      },
    },
  }
</script>

<style>
@media (min-width: 1200px) {
  .container {
    max-width: 1320px !important;
  }
}
</style>
